module.exports = __webpack_public_path__ + "img/背景2.8007eb1b.jpg";